import React from 'react'

export function Policy() {
  return (
    <div style={{ height: '100%', overflowY: 'auto', margin: '20px' }}>
        <nav className="navbar navbar-default navbar-fixed-top navbar-shrink">
          <div className="container">
            <div className="navbar-header page-scroll">
              <a className="navbar-brand page-scroll" href="https://dhundhoo.com/index.html" style={{ color: 'black', fontSize: '20px' }}><strong>Dhundhoo</strong></a>
            </div>
          </div>
        </nav>


        <div className="container" id="auto">


          <p align="center">
            <strong><u>Privacy Policy</u></strong>
          </p>

          <br />
          <div className="row">
            <div className="col-lg-12">
              <p>
                This document is an electronic record in terms of Information Technology Act, 2000 and rules there under as applicable and the amended provisions
                pertaining to electronic records in various statutes as amended by the Information Technology Act, 2000. This electronic record is generated by a computer
                system and does not require any physical or digital signatures.
              </p>
            </div>
          </div>

          <div className="row">
            <div className="col-lg-12">
              <p>
                This document is published in accordance with the provisions of Rule 3 (1) of the Information Technology (Intermediaries guidelines) Rules, 2011 that
                require publishing the rules and regulations, privacy policy and Terms of Use for access or usage of <a href="http://www.dhundhoo.com"><u>www.dhundhoo.com</u></a>, <a href="http://www.dhundhoo.com"><u>www.dhundhoo.in</u></a>, Dhundhoo Mobile App.
              </p>
              <p>
                <a href="http://www.dhundhoo.com"><u>www.dhundhoo.com</u></a>, <a href="http://www.dhundhoo.com"><u>www.dhundhoo.in</u></a>, Dhundhoo Mobile App and affiliates respect your privacy. This Privacy Policy describes in
                brief the manner in which your data is collected and used by <a href="http://www.dhundhoo.com"><u>www.dhundhoo.com</u></a>, <a href="http://www.dhundhoo.com"><u>www.dhundhoo.in</u></a> , Dhundhoo Mobile App. You are advised to please read the Privacy Policy carefully. By
                accessing the website <a href="http://www.dhundhoo.com"><u>www.dhundhoo.com</u></a>, <a href="http://www.dhundhoo.com"><u>www.dhundhoo.in</u></a>,
                Dhundhoo Mobile App, you agree to the collection and use of your data by <a href="http://www.dhundhoo.com"><u>www.dhundhoo.com</u></a>, <a href="http://www.dhundhoo.com"><u>www.dhundhoo.in</u></a>, Dhundhoo Mobile App in the manner provided in this Privacy Policy.
              </p>
            </div>
          </div>
          <br />

          <div className="row">
            <div className="col-lg-12">
              <p>
                <strong>WE WANT YOU TO</strong><br /><br />
                <ul>
                  <li>
                    Feel comfortable using our web site
                  </li>
                  <li>
                    Feel absolutely secure submitting information to us
                  </li>
                  <li>
                    Contact us with your questions or concerns about privacy on this site
                  </li>
                  <li>
                    Know that by using our site you are consenting to the collection of certain data
                  </li>
                </ul>
              </p>
              <br />
              <p>
                <strong>WHAT INFORMATION IS, OR MAY BE, COLLECTED FROM YOU?</strong>
                <br /><br />
                We will automatically receive and collect certain anonymous information in standard usage logs through our Web server, including computer-identification
                information obtained from "cookies," sent to your browser from a
              </p>
              <ul>
                <li>
                  web server cookie stored on your hard drive
                </li>
                <li>
                  an IP address, assigned to the computer which you use
                </li>
                <li>
                  the domain server through which you access our service
                </li>
                <li>
                  the type of computer you're using
                </li>
                <li>
                  the type of web browser you're using
                </li>
                <li>
                  the device id’s and other details
                </li>
              </ul>
              <br />
              <p>
                <strong>We may collect the following sensitive personal data or information (SPDI) about you: </strong>
                <br /><br />
                In case, you are a parent, the following SPDI is collected
              </p>
              <ul>
                <li>
                  Name
                </li>
                <li>
                  Address
                </li>
                <li>
                  Mobile No
                </li>
                <li>
                  Email id
                </li>
                <li>
                  Name of the School- in which your child/ children are studying
                </li>
                <li>
                  Date of birth- Child/ Children
                </li>
                <li>
                  Blood Group- Child/ Children
                </li>
                <li>
                  className and Roll no- Child/ Children
                </li>
                <li>
                  Emergency Contact details
                </li>
                <li>
                  Bus Stop Information
                </li>
                <li>
                  Any other information required for providing service to you
                </li>
              </ul>
              <br />
              <p>
                <strong>In case you are a Conductor/ Driver, the following SPDI about you is collected</strong>
              </p><br />
              <ul>
                <li>
                  Name
                </li>
                <li>
                  Mobile No
                </li>
                <li>
                  Address
                </li>
                <li>
                  Driving License
                </li>
                <li>
                  ID Proof
                </li>
                <li>
                  Live location from Driver Mobile App during journey time to share it with parents and School Team.
                </li>
                <li>
                  Our app continuously collects location data during school hours, even when the app is closed or not in use. This data is used to display the bus's real-time location on a map. We may share your location data with the school administration to enhance student tracking and ensure their safety during transportation. We implement stringent measures to safeguard the collected location data from unauthorized access, alteration, disclosure, or destruction.
                </li>
                <br />
                <li>
                  Live employee location during working hours is shared with the organization’s admin to help track field tasks and ensure safety.
                </li>
                <li>
                  Our app continuously collects location data during assigned work hours, even when the app is closed or running in the background. This information is used to display the employee’s real-time location on the admin dashboard. We may share your location data only with authorized organization administrators to improve task monitoring, coordination, and employee safety during field operations. Robust security measures are implemented to protect all location data from unauthorized access, misuse, or disclosure.
                </li>
              </ul>
              <br />
              <p>
                <strong>In case you are a School/ Educational Institution, the following SPDI is collected </strong>
              </p><br />
              <ul>
                <li>
                  Name of your School/ Educational Institution
                </li>
                <li>
                  Mobile No of the School/ Educational Institution
                </li>
                <li>
                  Name, Designation, Mobile No of the authorized personnel of your School/ Educational Institution using        <a href="http://www.dhundhoo.com"><u>www.dhundhoo.com</u></a> , <a href="http://www.dhundhoo.com"><u>www.dhundhoo.in</u></a> , Dhundhoo Mobile App
                </li>
                <li>
                  Information and Details of Buses-including all papers, vehicle number plates etc.
                </li>
                <li>
                  Database of information of all Students
                </li>
              </ul>
              <br />
              <p>
                <strong>We may also collect the following information: </strong>
              </p><br />
              <ul>
                <li>
                  about the pages you visit / access
                </li>
                <li>
                  the links you click on <a href="http://www.dhundhoo.com"><u>www.dhundhoo.com</u></a> , <a href="http://www.dhundhoo.com"><u>www.dhundhoo.in</u></a> ,
                  Dhundhoo Mobile App
                </li>
                <li>
                  he number of times you access a page on <a href="http://www.dhundhoo.com"><u>www.dhundhoo.com</u></a> ,    <a href="http://www.dhundhoo.com"><u>www.dhundhoo.in</u></a> , Dhundhoo Mobile App
                </li>
              </ul>
              <br />
              <p>
                <strong>WHO COLLECTS THE INFORMATION</strong>
                <br /><br />
                Some of your sensitive personal data or information may be collected, received, possessed, stored, dealt with or handled by:
                <p>
                  <strong>Trackula Services Pvt Ltd</strong>
                  <br />
                  <strong># Plot No.442, Hari Darshan Sindhu Balodyan, Jaripatka Nagpur, Maharashtra- 440014 </strong>
                </p>
              </p>
              <p>
                We will collect anonymous traffic information from you when you access <a href="http://www.dhundhoo.com"><u>www.dhundhoo.com</u></a> ,    <a href="http://www.dhundhoo.com"><u>www.dhundhoo.in</u></a> , Dhundhoo Mobile App
                <br />
                We may collect sensitive personal data or identifiable information about you only as a part of a voluntary registration process.
              </p>
              <br />
              <p>
                <strong>HOW IS THE INFORMATION USED?</strong>
                <br /><br />
                <strong>We use your sensitive personal information to:</strong><br /><br />
                <ul>
                  <li>
                    help us provide personalized features
                  </li>
                  <li>
                    tailor <a href="http://www.dhundhoo.com"><u>www.dhundhoo.com</u></a> , <a href="http://www.dhundhoo.com"><u>www.dhundhoo.in</u></a> , Dhundhoo Mobile App
                    to your interest
                  </li>
                  <li>
                    to get in touch with you when necessary
                  </li>
                  <li>
                    to provide the services requested by you
                  </li>
                  <li>
                    to preserve social history as governed by existing law or policy
                  </li>
                </ul>
              </p>
              <br />
              <p>
                <strong>We use contact information internally to:</strong>
              </p>
              <ul>
                <li>
                  direct our efforts for improvement
                </li>
              </ul>
              <br />
              <p>
                <strong>Generally, we use anonymous traffic information to:</strong>
              </p><br />
              <ul>
                <li>
                  remind us of who you are in order to deliver to you a better and more personalized service;
                </li>
                <li>
                  recognize your access privileges to <a href="http://www.dhundhoo.com"><u>www.dhundhoo.com</u></a> ,    <a href="http://www.dhundhoo.com"><u>www.dhundhoo.in</u></a> , Dhundhoo Mobile App
                </li>
                <li>
                  help diagnose problems with our server, <a href="http://www.dhundhoo.com"><u>www.dhundhoo.com</u></a> ,    <a href="http://www.dhundhoo.com"><u>www.dhundhoo.in</u></a> , Dhundhoo Mobile App
                </li>
                <li>
                  administer <a href="http://www.dhundhoo.com"><u>www.dhundhoo.com</u></a> , <a href="http://www.dhundhoo.com"><u>www.dhundhoo.in</u></a> , Dhundhoo Mobile
                  App
                </li>
                <li>
                  track your session so that we can understand better how people use <a href="http://www.dhundhoo.com"><u>www.dhundhoo.com</u></a> ,    <a href="http://www.dhundhoo.com"><u>www.dhundhoo.in</u></a> , Dhundhoo Mobile App
                </li>
              </ul>
              <br />
              <p>
                <strong>DISCLOSURE POLICY IN COMPLIANCE WITH RULE 6 OF THE IT RULES 2011</strong>
                <br /><br />
                The sensitive personal data or information may be disclosed to any person, if such disclosure is required for a lawful purpose connected with a function or
                activity of <a href="http://www.dhundhoo.com"><u>www.dhundhoo.com</u></a> , <a href="http://www.dhundhoo.com"><u>www.dhundhoo.in</u></a> , Dhundhoo Mobile
                App.

                The sensitive personal data or information may be disclosed, where the disclosure is necessary for compliance of a legal obligation.
              </p>
              <p>
                We do not rent, sell, publish or share your sensitive personal data and we will not disclose any of your personally identifiable information unless    <strong>:</strong><strong></strong>
              </p>
              <ul>
                <li>
                  we have your permission
                </li>
                <li>
                  to help investigate, prevent or take action regarding unlawful and illegal activities, suspected fraud, including cyber incidents potential threat,
                  punishment of offences and to the safety or security of any person, violations of <a href="http://www.dhundhoo.com"><u>www.dhundhoo.com</u></a> ,    <a href="http://www.dhundhoo.com"><u>www.dhundhoo.in</u></a> , Dhundhoo Mobile App ‘s terms of use or to defend against legal claims;
                </li>
                <li>
                  Special circumstances such as compliance with subpoenas, court orders, requests/order from legal authorities or law enforcement agencies requiring such
                  disclosure.
                </li>
              </ul>
              <br />
              <p>
                <strong>WHAT CHOICES ARE AVAILABLE TO YOU REGARDING COLLECTION, USE AND DISTRIBUTION OF YOUR INFORMATION?</strong><br /><br />
              </p>
              <p>
                Sharing your sensitive personal identifiable information is entirely voluntary. You need not register with us in order to use    <a href="http://www.dhundhoo.com"><u>www.dhundhoo.com</u></a> , <a href="http://www.dhundhoo.com"><u>www.dhundhoo.in</u></a> , Dhundhoo Mobile App. However,
                we offer some services only to visitors who register. You may opt-in or opt-out of any services/ marketing / promotions. You may update your information
                and change your account settings at any time.
              </p>
              <p>
                Upon request, we will remove/block your sensitive personal identifiable information from our database, thereby cancelling your registration. However, your
                information may remain stored in archive on our servers even after the deletion or the termination of your account.
              </p>
              <p>
                If we plan to use your sensitive personal identifiable information for any commercial purposes, we will notify you at the time we collect that information
                and allow you to opt-out of having your information used for those purposes.
                <br />
                You can accept or decline the cookies. All sites that are customizable require that you accept cookies. You also must accept cookies to register as someone
                for access to some of our services. For information on how to set your browser to alert you to cookies, or to reject cookies, go to    <a href="http://www.cookiecentral.com/faq/"><u>http://www.cookiecentral.com/faq/</u></a>.
              </p>
              <br />
              <p>
                <strong>WHAT SECURITY PROCEDURES ARE IN PLACE TO PROTECT INFORMATION FROM LOSS, MISUSE OR ALTERATION?</strong>
                <br /><br />
                To protect against the loss, misuse and alteration of the information under our control, and to comply with Rule 8 of IT Rules, 2011 (Reasonable security
                practices and procedures and sensitive personal data or information), we have in place appropriate physical, electronic, technical, operational and
                managerial procedures.
              </p>
              <p>
                Our servers are accessible only to authorized personnel and your information is shared with respective personnel to complete the transaction and to provide
                the services requested by you.
              </p>
              <p>
                Although we will endeavor to safeguard the confidentiality of your sensitive personal identifiable information, transmissions made by means of the Internet
                cannot be made absolutely secure. By browsing, accessing, using <a href="http://www.dhundhoo.com"><u>www.dhundhoo.com</u></a> ,    <a href="http://www.dhundhoo.com"><u>www.dhundhoo.in</u></a> , Dhundhoo Mobile App in whatsoever manner, you agree that we shall have no liability for
                disclosure of your information due to errors in transmission or unauthorized acts of third parties including any cyber-attacks.
              </p>
              <br />
              <p>
                <strong>HOW CAN YOU CORRECT INACCURACIES IN THE INFORMATION?</strong>
                <br /><br />
                To correct or update any information you have provided during registration, you can update or correct the inaccuracies therein through your registered
                account. However, you shall be responsible for informing us the same.
                <br />
                In the event of loss of access details you may send an e-mail to <a href="mailto:info@dhundhoo.com"><u>info@dhundhoo.com</u></a>
              </p>
              <br />
              <p>
                <strong>POLICY UPDATES</strong>
                <br /><br />
                We reserve the right to change or update this policy at any time by placing a prominent notice on our site. Such changes shall be effective immediately
                upon posting the same on <a href="http://www.dhundhoo.com"><u>www.dhundhoo.com</u></a> , <a href="http://www.dhundhoo.com"><u>www.dhundhoo.in</u></a> ,
                Dhundhoo Mobile App.
              </p>

              <br />
              <div>
                <span className="copyright">Copyright © Trackula Services Pvt Ltd 2018</span>
              </div>
              <br />

            </div>
          </div>
        </div>

      </div>

  )
}

export default Policy